import React, { useState } from "react";
import Recorder from "../../QuestionPage/recorder";
import ExamPanel from "../ExamPanel";

export default function ReadAloudPage({ question, onInputChange, questionNumber, ...props }) {
  const [text, setText] = useState("");

  const handleTextChange = (newText) => {
    if (newText !== text) {
      setText(newText);
      onInputChange(newText);
    }
  };

  return (
    <ExamPanel
      eyebrow="Speaking"
      title="Read Aloud"
      questionLabel={`Question ${questionNumber} of 36`}
      instructions="Look at the text below. In 35 seconds, read this text aloud as naturally and clearly as possible."
    >
      <div className="grid gap-6 lg:grid-cols-[minmax(320px,1fr),420px] lg:items-start">
        <article className="rounded-md border border-slate-200 bg-slate-50 p-5 text-base leading-8 text-gray-800">
          {question?.question || "Question text is loading..."}
        </article>

        <div className="rounded-md border border-slate-200 bg-white p-4">
          <Recorder
            text={text}
            setText={handleTextChange}
            {...props}
            duration={20}
            className="min-h-56 w-full rounded-md border border-slate-200 bg-slate-50"
          />
        </div>
      </div>
    </ExamPanel>
  );
}
